import React from "react";
import styled from "styled-components";
import QRCode from "react-qr-code";
import CustomImage from "../../../common/components/image/CustomImage";
import { Theme } from "../../../common/Theme";
import { buildQrValue } from "../utils/qrValue";

const CardContainer = styled.div`
    width: 343px;
    height: 187px;
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    font-family: "Inter", sans-serif;
    margin-bottom: 12px;
`;

const TopSection = styled.div`
    flex: 1;
    background-color: ${Theme.color.neutral600};
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
`;

const ScanTitle = styled.h2`
    color: white;
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    line-height: 1.1;
`;

const SubText = styled.p`
    color: ${Theme.color.white};
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    /* 아이콘과 정렬을 맞추기 위해 왼쪽 여백 없이 배치 */
`;

const BottomSection = styled.div`
    flex: 1;
    background-color: ${Theme.color.gray200};
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const StoreText = styled.span`
    font-size: 14px;
    color: ${Theme.color.stone500};
    margin-bottom: 2px;
`;

const DeviceText = styled.span`
    font-size: 20px;
    font-weight: 800;
    color: ${Theme.color.black};
`;

const QrWrapper = styled.div`
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    width: 145px;
    height: 145px;
    background-color: ${Theme.color.white};
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px ${Theme.color.black_01};
    z-index: 10;
`;

const QRPrintContent = React.forwardRef(({ device, storeId, storeName }, ref) => {
    const deviceId = device?.deviceId;
    const qrValue = deviceId ? buildQrValue({ deviceId, storeId }) : null;

    return (
        <CardContainer ref={ref}>
            <TopSection>
                <TitleRow>
                    <CustomImage width={"25px"} height={"42px"} imageName={"image_mobile_phone"} />
                    <ScanTitle>
                        Scan
                        <br />
                        QR Code
                    </ScanTitle>
                </TitleRow>
                <SubText>With Laundry Crew App</SubText>
            </TopSection>

            <BottomSection>
                <StoreText>{storeName || ""}</StoreText>
                <DeviceText>{device?.alias || ""}</DeviceText>
            </BottomSection>

            <QrWrapper>
                {qrValue && <QRCode value={qrValue} size={130} level={"L"} />}
            </QrWrapper>
        </CardContainer>
    );
});

export default QRPrintContent;
